import { render } from "./EmailConfirmed.vue?vue&type=template&id=74584622"
import script from "./EmailConfirmed.vue?vue&type=script&lang=js"
export * from "./EmailConfirmed.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__